/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface Wipay
 */
export interface Wipay {
    /**
     * Whether Wipay payment integration is enabled
     * @type {boolean}
     * @memberof Wipay
     */
    isWipayApiEnabled?: boolean;
    /**
     * Wipay API key for authentication
     * @type {string}
     * @memberof Wipay
     */
    wipayApiKey?: string;
    /**
     * Wipay account number
     * @type {string}
     * @memberof Wipay
     */
    wipayAccountNumber?: string;
    /**
     * Wipay country code
     * @type {string}
     * @memberof Wipay
     */
    wipayCountryCode?: string;
    /**
     * Wipay currency code
     * @type {string}
     * @memberof Wipay
     */
    wipayCurrency?: string;
    /**
     * Wipay response URL for callbacks
     * @type {string}
     * @memberof Wipay
     */
    wipayResponseUrl?: string;
    /**
     * Wipay environment (sandbox/production)
     * @type {string}
     * @memberof Wipay
     */
    wipayEnvironment?: string;
    /**
     * Wipay fee structure
     * @type {string}
     * @memberof Wipay
     */
    wipayFeeStructure?: string;
    /**
     * Wipay API base URL
     * @type {string}
     * @memberof Wipay
     */
    wipayApiBaseUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof Wipay
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Wipay
     */
    courierId?: number;
}

/**
 * Check if a given object implements the Wipay interface.
 */
export function instanceOfWipay(value: object): value is Wipay {
    return true;
}

export function WipayFromJSON(json: any): Wipay {
    return WipayFromJSONTyped(json, false);
}

export function WipayFromJSONTyped(json: any, ignoreDiscriminator: boolean): Wipay {
    if (json == null) {
        return json;
    }
    return {
        'isWipayApiEnabled': json['isWipayApiEnabled'] == null ? undefined : json['isWipayApiEnabled'],
        'wipayApiKey': json['wipayApiKey'] == null ? undefined : json['wipayApiKey'],
        'wipayAccountNumber': json['wipayAccountNumber'] == null ? undefined : json['wipayAccountNumber'],
        'wipayCountryCode': json['wipayCountryCode'] == null ? undefined : json['wipayCountryCode'],
        'wipayCurrency': json['wipayCurrency'] == null ? undefined : json['wipayCurrency'],
        'wipayResponseUrl': json['wipayResponseUrl'] == null ? undefined : json['wipayResponseUrl'],
        'wipayEnvironment': json['wipayEnvironment'] == null ? undefined : json['wipayEnvironment'],
        'wipayFeeStructure': json['wipayFeeStructure'] == null ? undefined : json['wipayFeeStructure'],
        'wipayApiBaseUrl': json['wipayApiBaseUrl'] == null ? undefined : json['wipayApiBaseUrl'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function WipayToJSON(value?: Wipay | null): any {
    if (value == null) {
        return value;
    }
    return {
        'isWipayApiEnabled': value['isWipayApiEnabled'],
        'wipayApiKey': value['wipayApiKey'],
        'wipayAccountNumber': value['wipayAccountNumber'],
        'wipayCountryCode': value['wipayCountryCode'],
        'wipayCurrency': value['wipayCurrency'],
        'wipayResponseUrl': value['wipayResponseUrl'],
        'wipayEnvironment': value['wipayEnvironment'],
        'wipayFeeStructure': value['wipayFeeStructure'],
        'wipayApiBaseUrl': value['wipayApiBaseUrl'],
        'id': value['id'],
        'courierId': value['courierId'],
    };
}
